import React from "react";
import { Donate, Footer, Header } from "shared";
import { Gallery } from "./fragments/gallery";
import { MemberList } from "./fragments/member-list";
import { ServiceList } from "./fragments/service-list";
import styles from "./Home.styles";

export const Home: React.FC = () => {
	return (
		<>
			<Header />
			<main>
				<div css={styles.quote}>
					<h3>
						Terapija i rehabilitacija djece i osoba s poteškoćama u razvoju
						pomoću konja.
					</h3>
				</div>
				<div css={styles.hero}>
					<img
						src="/images/hero.jpg"
						alt="Udruga 4 Lista"
						css={styles.heroImage}
					/>
					<h4>"Konji nam posuđuju krila koja mi nemamo." &mdash; Pam Brown</h4>
				</div>

				<div css={styles.rest}>
					<ServiceList />
					<Donate />
					<MemberList />
					<Gallery />
					<Footer />
				</div>
			</main>
		</>
	);
};
